<div class="main-content">
	<div class="container-fluid">
		<div class="card">
			<div class="card-header card-header-{{color}}">
				<h4 class="card-title">
					<i class="material-icons" (click)="back()" style="cursor:pointer">arrow_left</i>
					Channel Reports
				</h4>
				<p class="card-category">Sales analytics for LeafLink &amp; Distru channels</p>
			</div>
			<div class="card-body">

				<!-- Filters -->
				<div class="row mb-4 align-items-end">
					<div class="col-md-2">
						<mat-form-field appearance="fill" class="w-100">
							<mat-label>From</mat-label>
							<input matInput type="date" [(ngModel)]="filters.datefrom">
						</mat-form-field>
					</div>
					<div class="col-md-2">
						<mat-form-field appearance="fill" class="w-100">
							<mat-label>To</mat-label>
							<input matInput type="date" [(ngModel)]="filters.dateto">
						</mat-form-field>
					</div>
					<div class="col-md-2">
						<mat-form-field appearance="fill" class="w-100">
							<mat-label>Channel</mat-label>
							<mat-select [(ngModel)]="filters.channel">
								<mat-option value="">All</mat-option>
								<mat-option value="leaflink">LeafLink</mat-option>
								<mat-option value="distru">Distru</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="col-md-2">
						<button mat-raised-button color="primary" (click)="load()" [disabled]="loading">
							<mat-icon>refresh</mat-icon> Refresh
						</button>
					</div>
				</div>

				<div *ngIf="loading" class="text-center py-5"><mat-spinner diameter="48"></mat-spinner></div>

				<ng-container *ngIf="!loading">

					<!-- KPI Cards -->
					<div class="row mb-4">
						<div class="col-md-3">
							<div class="kpi-card kpi-card--blue">
								<div class="kpi-label">LeafLink Orders</div>
								<div class="kpi-value">{{ getChannelStat('leaflink').order_count }}</div>
								<div class="kpi-sub">{{ getChannelStat('leaflink').revenue | currency }}</div>
							</div>
						</div>
						<div class="col-md-3">
							<div class="kpi-card kpi-card--green">
								<div class="kpi-label">Distru Orders</div>
								<div class="kpi-value">{{ getChannelStat('distru').order_count }}</div>
								<div class="kpi-sub">{{ getChannelStat('distru').revenue | currency }}</div>
							</div>
						</div>
						<div class="col-md-3">
							<div class="kpi-card kpi-card--purple">
								<div class="kpi-label">Total Revenue</div>
								<div class="kpi-value">{{ totalRevenue() | currency }}</div>
								<div class="kpi-sub">Both channels</div>
							</div>
						</div>
						<div class="col-md-3">
							<div class="kpi-card kpi-card--orange">
								<div class="kpi-label">LL Failed Pushes</div>
								<div class="kpi-value">{{ stats?.ll_push?.failed || 0 }}</div>
								<div class="kpi-sub">{{ stats?.distru_push?.failed || 0 }} Distru failed</div>
							</div>
						</div>
					</div>

					<!-- Channel share bars -->
					<div class="row mb-4">
						<div class="col-md-6">
							<div class="share-bar-wrap">
								<div class="share-bar-label">LeafLink share {{ channelShare('leaflink') }}%</div>
								<div class="share-bar">
									<div class="share-bar-fill share-bar-fill--blue" [style.width.%]="channelShare('leaflink')"></div>
								</div>
							</div>
						</div>
						<div class="col-md-6">
							<div class="share-bar-wrap">
								<div class="share-bar-label">Distru share {{ channelShare('distru') }}%</div>
								<div class="share-bar">
									<div class="share-bar-fill share-bar-fill--green" [style.width.%]="channelShare('distru')"></div>
								</div>
							</div>
						</div>
					</div>

					<!-- Queue stat cards -->
					<div class="row mb-4" *ngIf="stats">
						<div class="col-md-6">
							<div class="queue-card">
								<div class="queue-card-title queue-card-title--ll">LeafLink Queue</div>
								<div class="row text-center">
									<div class="col-3"><div class="queue-num">{{ stats.ll_push?.pushed || 0 }}</div><div class="queue-lbl">Pushed</div></div>
									<div class="col-3"><div class="queue-num text-warning">{{ stats.ll_push?.pending || 0 }}</div><div class="queue-lbl">Pending</div></div>
									<div class="col-3"><div class="queue-num text-danger">{{ stats.ll_push?.failed || 0 }}</div><div class="queue-lbl">Failed</div></div>
									<div class="col-3"><div class="queue-num text-muted">{{ stats.ll_inbound?.pending || 0 }}</div><div class="queue-lbl">In Queue</div></div>
								</div>
							</div>
						</div>
						<div class="col-md-6">
							<div class="queue-card">
								<div class="queue-card-title queue-card-title--distru">Distru Queue</div>
								<div class="row text-center">
									<div class="col-3"><div class="queue-num">{{ stats.distru_push?.pushed || 0 }}</div><div class="queue-lbl">Pushed</div></div>
									<div class="col-3"><div class="queue-num text-warning">{{ stats.distru_push?.pending || 0 }}</div><div class="queue-lbl">Pending</div></div>
									<div class="col-3"><div class="queue-num text-danger">{{ stats.distru_push?.failed || 0 }}</div><div class="queue-lbl">Failed</div></div>
									<div class="col-3"><div class="queue-num text-muted">{{ stats.distru_inbound?.pending || 0 }}</div><div class="queue-lbl">In Queue</div></div>
								</div>
							</div>
						</div>
					</div>

					<!-- Trend table -->
					<div class="card mb-4">
						<div class="card-header trend-header">Monthly Trend</div>
						<div class="card-body p-0">
							<mat-table [dataSource]="trends">
								<ng-container matColumnDef="period">
									<mat-header-cell *matHeaderCellDef>Period</mat-header-cell>
									<mat-cell *matCellDef="let r">{{ r.period }}</mat-cell>
								</ng-container>
								<ng-container matColumnDef="channel">
									<mat-header-cell *matHeaderCellDef>Channel</mat-header-cell>
									<mat-cell *matCellDef="let r">
										<span class="badge" [ngClass]="r.channel === 'leaflink' ? 'badge-ll' : 'badge-ds'">
											{{ r.channel === 'leaflink' ? 'LeafLink' : 'Distru' }}
										</span>
									</mat-cell>
								</ng-container>
								<ng-container matColumnDef="order_count">
									<mat-header-cell *matHeaderCellDef>Orders</mat-header-cell>
									<mat-cell *matCellDef="let r">{{ r.order_count }}</mat-cell>
								</ng-container>
								<ng-container matColumnDef="revenue">
									<mat-header-cell *matHeaderCellDef>Revenue</mat-header-cell>
									<mat-cell *matCellDef="let r">{{ r.revenue | currency }}</mat-cell>
								</ng-container>
								<mat-header-row *matHeaderRowDef="['period','channel','order_count','revenue']"></mat-header-row>
								<mat-row *matRowDef="let r; columns:['period','channel','order_count','revenue']"></mat-row>
							</mat-table>
							<p *ngIf="trends.length === 0" class="text-muted text-center py-3">No trend data</p>
						</div>
					</div>

					<!-- Top Products -->
					<div class="card mb-4">
						<div class="card-header trend-header">Top Products</div>
						<div class="card-body p-0">
							<mat-table [dataSource]="topProducts">
								<ng-container matColumnDef="rank">
									<mat-header-cell *matHeaderCellDef>#</mat-header-cell>
									<mat-cell *matCellDef="let r">{{ r.rank }}</mat-cell>
								</ng-container>
								<ng-container matColumnDef="stkcode">
									<mat-header-cell *matHeaderCellDef>SKU</mat-header-cell>
									<mat-cell *matCellDef="let r">{{ r.stkcode }}</mat-cell>
								</ng-container>
								<ng-container matColumnDef="description">
									<mat-header-cell *matHeaderCellDef>Description</mat-header-cell>
									<mat-cell *matCellDef="let r">{{ r.description }}</mat-cell>
								</ng-container>
								<ng-container matColumnDef="channel">
									<mat-header-cell *matHeaderCellDef>Channel</mat-header-cell>
									<mat-cell *matCellDef="let r">
										<span class="badge" [ngClass]="r.channel === 'leaflink' ? 'badge-ll' : 'badge-ds'">
											{{ r.channel === 'leaflink' ? 'LL' : 'DS' }}
										</span>
									</mat-cell>
								</ng-container>
								<ng-container matColumnDef="total_qty">
									<mat-header-cell *matHeaderCellDef>Qty</mat-header-cell>
									<mat-cell *matCellDef="let r">{{ r.total_qty }}</mat-cell>
								</ng-container>
								<ng-container matColumnDef="total_revenue">
									<mat-header-cell *matHeaderCellDef>Revenue</mat-header-cell>
									<mat-cell *matCellDef="let r">{{ r.total_revenue | currency }}</mat-cell>
								</ng-container>
								<ng-container matColumnDef="order_count">
									<mat-header-cell *matHeaderCellDef>Orders</mat-header-cell>
									<mat-cell *matCellDef="let r">{{ r.order_count }}</mat-cell>
								</ng-container>
								<mat-header-row *matHeaderRowDef="topProductColumns"></mat-header-row>
								<mat-row *matRowDef="let r; columns: topProductColumns"></mat-row>
							</mat-table>
						</div>
					</div>

					<!-- Brand Accordion -->
					<div class="card mb-4">
						<div class="card-header trend-header">Brand Breakdown</div>
						<div class="card-body p-0">
							<div *ngFor="let b of brands" class="brand-accordion">
								<div class="brand-header" (click)="toggleBrand(b.brand)">
									<span>{{ b.brand }}</span>
									<span class="ms-auto">{{ b.total_revenue | currency }}</span>
									<mat-icon class="chevron" [ngClass]="{'chevron--open': isBrandExpanded(b.brand)}">expand_more</mat-icon>
								</div>
								<div class="brand-body" *ngIf="isBrandExpanded(b.brand)">
									<div *ngFor="let ch of b.channels" class="brand-channel-row">
										<span class="badge" [ngClass]="ch.channel === 'leaflink' ? 'badge-ll' : 'badge-ds'">
											{{ ch.channel === 'leaflink' ? 'LeafLink' : 'Distru' }}
										</span>
										<span class="ms-2">{{ ch.order_count }} orders</span>
										<span class="ms-auto">{{ ch.revenue | currency }}</span>
									</div>
								</div>
							</div>
							<p *ngIf="brands.length === 0" class="text-muted text-center py-3">No brand data</p>
						</div>
					</div>

				</ng-container>
			</div>
		</div>
	</div>
</div>
